import React from 'react'

import i18n from 'modules/core/lib/i18n'
import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/competencies/pages/profile/RootPage'))

const profileRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.profile.competencies.path,
      element: <RootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('competencies_v2.title'),
        }),
      },
    },
  ]
}

export default profileRoutes
